import axios from '../axios'

/* 
 * 三级联动
 */

// 省
export const province = () => {
        return axios({
                url: '/regions/getRegion',
                type: 'get',
                params: {
                        parentCode: 0,
                        level: 1
                }
        })
}

// 市
export const city = (parentCode, level) => {
        return axios({
                url: '/regions/getRegion',
                method: 'get',
                params: {
                        parentCode,
                        level
                }
        })
}
// 区
export const district = (parentCode, level) => {
        return axios({
                url: '/regions/getRegion',
                method: 'get',
                params: {
                        parentCode,
                        level
                }
        })
}
export const make = () => {
        return axios({
                url: '/make/findAll',
                method: 'get',
                params: {
                        makeName: "苹",
                        page: 1,
                        limit: 10
                }
        })
}


// WEBPACK FOOTER //
// ./src/http/moudules/area.js